import { vec2SequenceIsTurning } from "./vec2";

const NUM_STEPS = 16;

const baseTurnTolerance = Math.PI / 18;

function divideTurnToleranceByFactor(turnToleranceFactor: number) {
  if (turnToleranceFactor < 1) {
    turnToleranceFactor = 1;
  }

  return baseTurnTolerance / turnToleranceFactor;
}

function evalBezier2(t: number, p0: number, p1: number, p2: number) {
  const s = 1 - t;
  return s * s * p0 + 2 * s * t * p1 + t * t * p2;
}

export function evalBezier3(t: number, p0: number, p1: number, p2: number, p3: number) {
  const s = 1 - t;
  const u = 3 * s * t;
  return s * s * s * p0 + s * u * p1 + t * u * p2 + t * t * t * p3;
}

export function* quadraticCurveTo(
  fromX: number,
  fromY: number,
  controlX: number,
  controlY: number,
  toX: number,
  toY: number,
) {
  let prevx: number | null = null;
  let prevy: number | null = null;
  let prevprevx = fromX;
  let prevprevy = fromY;
  const step = 1 / NUM_STEPS;
  for (let t = step; t <= 1; t += step) {
    const fx = evalBezier2(t, fromX, controlX, toX);
    const fy = evalBezier2(t, fromY, controlY, toY);
    if (
      prevx !== null &&
      prevy !== null &&
      vec2SequenceIsTurning(prevprevx, prevprevy, prevx, prevy, fx, fy, baseTurnTolerance)
    ) {
      yield [t - step, prevx, prevy];
      prevprevx = prevx;
      prevprevy = prevy;
    }
    prevx = fx;
    prevy = fy;
  }
  yield [1.0, toX, toY];
}

export function* cubicCurveTo(
  fromX: number,
  fromY: number,
  control1X: number,
  control1Y: number,
  control2X: number,
  control2Y: number,
  toX: number,
  toY: number,
  turnToleranceFactor = 1,
) {
  let prevx: number | null = null;
  let prevy: number | null = null;
  let prevprevx = fromX;
  let prevprevy = fromY;

  const turnTolerance = divideTurnToleranceByFactor(turnToleranceFactor);

  const step = 1 / NUM_STEPS;
  for (let t = step; t <= 1; t += step) {
    const hx = evalBezier3(t, fromX, control1X, control2X, toX);
    const hy = evalBezier3(t, fromY, control1Y, control2Y, toY);
    if (
      prevx !== null &&
      prevy !== null &&
      vec2SequenceIsTurning(prevprevx, prevprevy, prevx, prevy, hx, hy, turnTolerance)
    ) {
      yield [t - step, prevx, prevy];
      prevprevx = prevx;
      prevprevy = prevy;
    }
    prevx = hx;
    prevy = hy;
  }
  yield [1.0, toX, toY];
}
